import React, { useState, useEffect, useRef } from 'react';
import { db } from '../firebase';
import { collection, query, onSnapshot, addDoc, orderBy, serverTimestamp } from 'firebase/firestore';
import './TaskChat.css';

const TaskChat = ({ taskId, user }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const chatEndRef = useRef(null);

  // Listen for real-time messages
  useEffect(() => {
    if (!taskId) return;

    const q = query(collection(db, 'tasks', taskId, 'comments'), orderBy('timestamp', 'asc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const msgs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setMessages(msgs);
    });

    return () => unsubscribe();
  }, [taskId]);

  // Auto-scroll to the latest message
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (newMessage.trim() === '' || isSending) return;

    setIsSending(true);
    try {
      // Add message to the 'comments' subcollection of the task
      await addDoc(collection(db, 'tasks', taskId, 'comments'), {
        text: newMessage,
        senderUid: user.uid,
        senderName: user.name, // Assuming user object has a name property
        timestamp: serverTimestamp(),
      });
      setNewMessage('');
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="task-chat-container">
      <h4>Update Task Progress & Discussions</h4>
      <div className="chat-messages">
        {messages.length === 0 && <p className="no-messages">No comments yet. Start the conversation!</p>}
        {messages.map(msg => (
          <div key={msg.id} className={`chat-message ${msg.senderUid === user.uid ? 'sent' : 'received'}`}>
            <div className="message-bubble">
              <strong className="message-sender">{msg.senderName}</strong>
              <p className="message-text">{msg.text}</p>
              <span className="message-time">
                {/* UPDATED LINE: 
                  Using toLocaleString() with options to show date and time.
                */}
                {msg.timestamp?.toDate().toLocaleString('en-IN', {
                  timeZone: 'Asia/Kolkata',
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }) + ' (IST)'}
              </span>
            </div>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>
      <form onSubmit={handleSendMessage} className="chat-form">
        <textarea
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type your message..."
          rows="3"
        />
        <button type="submit" disabled={isSending} data-tooltip="Post Comment">
          {isSending ? 'Posting...' : 'Post'}
        </button>
      </form>
    </div>
  );
};

export default TaskChat;